import React, { JSX, lazy, Suspense } from 'react';

const LazycontactUs = lazy(() => import('.'));

const contactUs = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazycontactUs {...props} />
  </Suspense>
);

export default contactUs;
